import WallpaperImage from '../../../Assets/court-wallpaper.png';
import useTranslate from '../../../Hooks/useTranslate';
import OverlayImage from '../../../Style-guide/OverlayImage';
import Title from '../../../Style-guide/Title';
import WallpaperWrapper from './style/wallpaperWrapper';

const Wallpaper = () => {
  const tr = useTranslate();

  return (
    <WallpaperWrapper>
      <div className='writings'>
        <Title>{tr('book_your_court_now')}</Title>
        <Title>{tr('we_are_waiting_for_your_team')}</Title>
      </div>
      <OverlayImage
        image={WallpaperImage}
        alt='wallpaper'
        imageClassName='wallpaper-image'
        containerClassName='wallpaper-image-container'
      />
    </WallpaperWrapper>
  );
};

export default Wallpaper;
